import React, { useContext } from 'react';
import { Dropdown, Avatar } from '@byte-design/ui';
import { observer } from 'mobx-react';
import styles from './index.module.scss';
import { globalInfoStoreContext } from '@/models/global';
import { useTranslation } from 'react-i18next';
import { logout } from '@/server/user';

function UserAvatar() {
  const { t } = useTranslation();
  const globalStore = useContext(globalInfoStoreContext);
  const { user } = globalStore;

  return (
    <div className={styles.user}>
      <Dropdown
        trigger="click"
        placement="bottom-end"
        menu={(
          <Dropdown.Menu onClick={(id: string) => {
            if (id === 'logout') {
              logout();
            }
          }}
          >
            <Dropdown.MenuItem id="logout">
              {t('logout')}
            </Dropdown.MenuItem>
          </Dropdown.Menu>
        )}
      >
        <Avatar src={user.avatar} size="sm" />
      </Dropdown>
    </div>
  );
}

export default React.memo(observer(UserAvatar));
